import { useNavigate } from "react-router-dom";
import { basePort, headers, setTokenHeader, getJwtFromCookies } from "../../module_auth/AuthService"
import { handleRefresch } from "../../component/common/BaseUtil"
import { useState, useEffect } from 'react';
import { ToastMessage } from "../../component/common/Toast"
import { ModalMessage } from "../../component/common/Modal"
import { INVALID_DELETE_AUTHORIZATION } from '../../component/common/Message'

export function ButtonEdit(props) {
    let navigate = useNavigate();    
    function onClick() {
        navigate(props.url + props.id);
    }
    return <button class="btn btn-outline-secondary" type="button" style={{marginRight: '5px'}} onClick={onClick}>수정</button>
}

export function ButtonDetail(props) {
    let navigate = useNavigate();    
    function onClick() {
        navigate(props.url + props.id);
    }
    return <button class="btn btn-outline-info" type="button" style={{marginRight: '5px'}} onClick={onClick}>상세보기</button>
}

export function ButtonDelete(props) {
    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    //modal
    const [showModal, setShowModal] = useState(false);

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }
    
    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    function closeModalBtn(){
        setShowModal(false)
    }

    function submitModalBtn(){
        setShowModal(false)
        onClick()
    }

    function clickModalBtn(){
        setShowModal(true)
    }

    function onClick() {
        console.log(props.id)
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + props.url, 
            {method:'post', headers,
                  body:JSON.stringify({
                    id:props.id
                })})
                  .then(response => response.json())
                  .then(response => {
                    if(response.validRequest){
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            handleRefresch()
                        }.bind(this), 3000)
                    } else {
                        //invalid by PreAuthorize
                        if(response.validationMessage == undefined){
                            fadeOutToast(INVALID_DELETE_AUTHORIZATION)
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
                    }
                    
                }
        ).catch(error => console.log(error))
    }
    return <><button class="btn btn-outline-danger" type="button" style={{marginRight: '5px'}} onClick={clickModalBtn}>삭제</button>
            <ToastMessage show={showToast} msg={msgToast}/>
            <ModalMessage show={showModal} closeBtn={closeModalBtn} submitBtn={submitModalBtn} title={"삭제 확인"} msg={props.objTitle} />
    </>
    
}

export function ButtonApproval(props) {
    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    //modal
    const [showModal, setShowModal] = useState(false);

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }
    
    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    function closeModalBtn(){
        setShowModal(false)
    }

    function submitModalBtn(){
        setShowModal(false)
        onClick()
    }

    function clickModalBtn(){
        setShowModal(true)
    }

    function onClick() {
        console.log(props.id)
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + props.url, 
            {method:'post', headers,
                  body:JSON.stringify({
                    id:props.id
                })})
                  .then(response => response.json())
                  .then(response => {
                    if(response.validRequest){
                        fadeOutToast(response.validationMessage)
                        setTimeout(function() {
                            handleRefresch()
                        }.bind(this), 3000)
                    } else {
                        //invalid by PreAuthorize
                        if(response.validationMessage == undefined){
                            fadeOutToast(INVALID_DELETE_AUTHORIZATION)
                        } else {
                            fadeOutToast(response.validationMessage)
                        }
                    }
                    
                }
        ).catch(error => console.log(error))
    }
    return <><button class="btn btn-outline-success" type="button" style={{marginRight: '5px'}} onClick={clickModalBtn}>승인</button>
            <ToastMessage show={showToast} msg={msgToast}/>
            <ModalMessage show={showModal} closeBtn={closeModalBtn} submitBtn={submitModalBtn} title={"승인"} msg={props.objTitle} />
    </>
    
}